import { useContext } from 'react'
import {
  GUEST_ENGAGEMENT_WISHLIST,
  OPTIMIZELY_VARIANT_KEYS,
} from '../../../constants'
import { GlobalProps } from '../../../utils/globalProps'

export function useWishlistEntryPoints(): boolean {
  const { experiments } = useContext(GlobalProps)

  const serverDecision = experiments?.[GUEST_ENGAGEMENT_WISHLIST]

  return (
    serverDecision === OPTIMIZELY_VARIANT_KEYS.WISHLIST_ENTRY_POINTS_VISIBLE
  )
}
